import type { MessageStatus, SystemMessage } from "@/models.ts";

export function parseBackendDate(value: string): Date {
  let cleaned = value
    .replace(/\.\d{1,7}(?=[Z+-]|$)/, "")
    .replace(/\+00:?00$/, "Z");
  if (!/(Z|[+-]\d{2}:?\d{2})$/.test(cleaned)) {
    cleaned += "Z";
  }
  return new Date(cleaned);
}

export function deriveStatus(
  startDate: Date | null,
  endDate: Date | null,
  now: Date = new Date()
): MessageStatus | null {
  if (!startDate || !endDate) return null;
  return classifyStatus(startDate, endDate, now);
}

export function deriveMessageStatus(
  message: SystemMessage,
  now: Date = new Date()
): MessageStatus {
  const startDate = parseBackendDate(message.startDate);
  const endDate = parseBackendDate(message.endDate);

  if (isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
    throw new Error(
      `Invalid date on system message ${message.id}: ` +
        `startDate=${JSON.stringify(message.startDate)}, ` +
        `endDate=${JSON.stringify(message.endDate)}`
    );
  }

  return classifyStatus(startDate, endDate, now);
}

function classifyStatus(
  startDate: Date,
  endDate: Date,
  now: Date
): MessageStatus {
  if (now > endDate) return "Past";
  if (now < startDate) return "Scheduled";
  return "Live";
}
